/**
 * Typewriter Effect Module
 * Animated text typing effect with configurable words
 */

class TypewriterEffect {
  constructor(options = {}) {
    this.element = options.element || document.getElementById('typewriter');
    this.words = options.words || [];
    this.typeSpeed = options.typeSpeed || 100;
    this.deleteSpeed = options.deleteSpeed || 50;
    this.pauseEnd = options.pauseEnd || 2000;
    this.pauseStart = options.pauseStart || 500;
    this.loop = options.loop !== false; // Default true

    this.wordIndex = 0;
    this.charIndex = 0;
    this.isDeleting = false;
    this.currentTimeout = null;
  }

  init() {
    if (!this.element || this.words.length === 0) {
      console.warn('Typewriter: No element or words provided');
      return;
    }

    // Start typing after initial pause
    this.currentTimeout = setTimeout(() => this.type(), this.pauseStart);
  }

  type() {
    const currentWord = this.words[this.wordIndex % this.words.length];
    let nextDelay = this.typeSpeed;

    if (this.isDeleting) {
      // Delete characters
      this.element.textContent = currentWord.substring(0, this.charIndex - 1);
      this.charIndex--;
      nextDelay = this.deleteSpeed;

      // Check if word is fully deleted
      if (this.charIndex === 0) {
        this.isDeleting = false;
        this.wordIndex++;

        // Check if should continue looping
        if (!this.loop && this.wordIndex >= this.words.length) {
          return; // Stop if not looping and reached end
        }

        nextDelay = this.pauseStart;
      }
    } else {
      // Type characters
      this.element.textContent = currentWord.substring(0, this.charIndex + 1);
      this.charIndex++;

      // Check if word is complete
      if (this.charIndex === currentWord.length) {
        nextDelay = this.pauseEnd;
        this.isDeleting = true;
      }
    }

    this.currentTimeout = setTimeout(() => this.type(), nextDelay);
  }

  stop() {
    if (this.currentTimeout) {
      clearTimeout(this.currentTimeout);
      this.currentTimeout = null;
    }
  }

  updateWords(newWords) {
    this.words = newWords;
    this.restart();
  }

  restart() {
    this.stop();
    this.wordIndex = 0;
    this.charIndex = 0;
    this.isDeleting = false;
    this.element.textContent = '';
    this.init();
  }
}

// Make TypewriterEffect globally available
window.TypewriterEffect = TypewriterEffect;